module.exports = __webpack_public_path__ + "static/media/1_en.38ed07bb.png";